import { useEcoRoutes } from 'hooks'
import { useRoutes } from 'react-router-dom'

export const Routes = () => useRoutes(useEcoRoutes())
